/* eslint-disable prettier/prettier */
import React from 'react';
import { Typography } from '@mui/material';
import getReadableDateTime from 'utils/get_readable_datetime';

const MatchCompletedTimestamp = ({ pool }) => {
    if (pool.status !== 'completed') {
        return <></>;
    }
    const displayText = getReadableDateTime(pool.updated_at, 'dayTime');
    return (
        <Typography variant="subtitle2" sx={{ pt: 1, minWidth: '78px' }} noWrap>
            {displayText}
        </Typography>
    );
};

export default MatchCompletedTimestamp; 